module.exports = __webpack_public_path__ + "store.png";